import { StyleSheet, Image, View } from 'react-native';
import { styles } from './styles';

export const FillerBody = () => {
  return (
    <View style={[StyleSheet.absoluteFillObject, styles.container]}>
      <Image
        source={require('../../assets/neolexon_Logo_ohneClaim.png')}
        alt={'NEOLEXON LOGO'}
        resizeMode="cover"
      />
    </View>
  );
};
